import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';


export default function MessageBoxWithAction(props) {
    const classes = useStyles();
    return (
        <div className={classes.outerWrapper}>
            <div className={classes.innerWrapper}>
                <div>
                    {props.children}
                </div>
                <div className={classes.buttons}>
                    {!props.doNotShowCancelButton ?
                        <Link href="#" onClick={props.cancel}>
                            Cancel
                        </Link>
                        : null
                    }
                    <Button id="submitButton" variant="contained" color="primary" onClick={props.ok}>
                        Ok
                        </Button>
                </div>
            </div>
        </div>
    )
}


const useStyles = makeStyles({
    root: {

    },
    outerWrapper: {
        zIndex: '1000',
        position: 'fixed',
        top: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(142, 137, 137, 0.7)',
        left: 0,
    },
    innerWrapper: {
        margin: 'auto',
        padding: '20px',
        borderRadius: '5px',
        marginTop: '100px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        width: '300px',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: '20px',
    }
});